<template>
  <div>
    <b-input-group
      class="mb-3"
      :class="[
        entity_idx == conn.entities.length - 1 ||
        entityHasVisibleMessage(entity)
          ? 'mb-md-0'
          : '',
      ]"
    >
      <template #prepend>
        <b-form-select
            ref="type"
            :state="
            isTypeInvalid(entity)
              ? false
              : isInputInvalid(entity)
              ? null
              : entity.id > 0 && !entity.isChanged('connection_type')
              ? null
              : true
          "
          v-model="entity.connection_type"
          @input.native="typeChanging"
          @input="typeChanged(conn_idx, entity, entity_idx)"
          :disabled="!canEditEntity()"
        >
          <b-form-select-option
            v-for="type in types"
            :key="type.value"
            :value="type.value"
            :disabled="license.isTypeDisabled(conn_idx, entity_idx, type)"
            >{{ $t(type.label) }}</b-form-select-option
          >
        </b-form-select>
      </template>

      <!--  -->
      <b-form-input
          ref="input"
        v-model="value"
        :class="{ 'encrypted-only': isEncryptedOnly }"
        :disabled="
          license.isWildcardEntity(entity) ||
          !canEditEntity()
        "
        :placeholder="getPlaceholder(entity)"
        :state="
          isInputInvalid(entity)
            ? false
            : isTypeInvalid(entity)
            ? null
            : entity.id > 0 && !entity.isChanged('name')
            ? null
            : true
        "
        :aria-describedby="'in_fb_' + conn_idx + '_' + entity_idx"
        @input="inputChanged(entity, conn_idx, entity_idx)"
      ></b-form-input>
      <b-input-group-append v-if="canDeleteEntity() || canSuspendEntity()">
        <b-button
          v-if="license.canDeleteConn(conn) || canEditEntity()"
          @click="handleDeleteEntity(conn_idx, entity_idx)"
          variant="editorBtn"
        >
          <b-icon-x-circle></b-icon-x-circle>
        </b-button>
        <b-input-group-text v-else>
          <b-form-checkbox
            switch
            class="mr-n2"
            v-model="active"
            v-b-tooltip.hover
            :title="entitySuspendingHint(entity)"
            :state="entity.id > 0 && !entity.isChanged('name') ? null : true"
          >
          </b-form-checkbox>
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <!-- === Сообщение валидации ========= -->
    <div v-if="entityHasVisibleMessage(entity)" class="validation mt-2 mb-3">
      <span
        v-for="(group, index) in entityVisibleGroups(entity)"
        :key="index"
        class="validation-mark text-light"
        :class="group.msg_type == 'warn' ? 'bg-warning' : 'bg-danger'"
        >{{ group.index }}</span
      >

      <template v-if="entityVisibleMessage(entity).msg_type == 'error'">
        <span class="ml-1 align-middle text-danger">{{
            entityVisibleMessage(entity).arg ? $t(entityVisibleMessage(entity).message, [$t(entityVisibleMessage(entity).arg)]) : $t(entityVisibleMessage(entity).message)
        }}</span>
      </template>
      <template v-else>
        <b-icon-exclamation-circle-fill
          variant="warning"
        ></b-icon-exclamation-circle-fill>
        <span class="ml-1 align-middle text-body">{{
            entityVisibleMessage(entity).arg ? $t(entityVisibleMessage(entity).message, [$t(entityVisibleMessage(entity).arg)]) : $t(entityVisibleMessage(entity).message)
        }}</span>
      </template>
    </div>
    <b-modal
        id="wildcard-modal"
        ok-only
        no-close-on-backdrop
        bodyClass="nice-modal"
        centered
        :okTitle="$t('button.close')"
        ok-variant="secondary"
        @ok="hideWildcardModal"
        @close="hideWildcardModal">
      <template #modal-title>
        {{ $t('license.wild_n_paid.h') }}
      </template>
      <div class="text-dark mb-3">{{ $t('license.wild_n_paid.msg') }}</div>
      <div class="mb-4">{{ $t('license.wild_n_paid.q') }}</div>
      <div class="d-block text-center">
        <b-button variant="primary" @click="handleCreateInNewSlot">{{ $t('license.wild_n_paid.action') }}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BIconXCircle, BIconExclamationCircleFill } from "bootstrap-vue";
import {
  ALLOWED_TYPES,
  isConNonPersonalTrial,
  isDraft,
  isConDraft,
  isConPaid,
  isConUnpaid,
  MSG_TYPE,
  WILDCARD,
  entIsWildcard, str2type
} from "@/components/rdbm/license.js";

let wildcardModalVisible = false;
let requestedType = null;

export default {
  name: "EntityInput",
  components: {
    BIconXCircle,
    BIconExclamationCircleFill,
  },
  props: ["license", "entity", "entity_idx", "conn", "conn_idx"],
  data() {
    return {
      types: ALLOWED_TYPES
    };
  },
  computed: {
    value: {
      get: function () {
        return this.isEncryptedOnly() ? "" : this.entity.name;
      },
      set: function (newValue) {
        this.entity.name = newValue;
      },
    },
    active: {
      get: function () {
        return !this.entity.suspended;
      },
      set: function (newValue) {
        this.entity.suspended = !newValue;
      },
    },
  },
  methods: {
    hasEncrypted: function () {
      return (
        this.entity.encoded_name && this.entity.encoded_name.startsWith("~")
      );
    },
    isEncryptedOnly: function () {
      return this.hasEncrypted() && this.entity.name.trim().startsWith("~");
    },
    getPlaceholder: function (entity) {
      if (this.isEncryptedOnly()) {
        return new Array(this.entity.encoded_name.length).join("•");
      } else {
        switch (entity.connection_type) {
          case "H":
            return this.$t('license.placeholders.host');
          case "D":
            return this.$t('license.placeholders.db');
        }
      }
    },
    isTypeInvalid: function (entity) {
      return (
        entity._validation.groups.length > 0 &&
        entity._validation.groups.find(
          (g) => g.isInput == false && g.msg_type == MSG_TYPE.ERROR
        )
      );
    },
    isInputInvalid: function (entity) {
      return (
        entity._validation.groups.length > 0 &&
        entity._validation.groups.find(
          (g) => g.isInput == true && g.msg_type == MSG_TYPE.ERROR
        )
      );
    },
    canEditEntity: function () {
      return (
        // Еще не сохраненное
        this.license.data._new || this.conn._new ||
        // Набросок
        isDraft(this.license.data) || isConDraft(this.conn) ||
        // Месячный триал, пока имя не сохранено и не скаченно
        (isConNonPersonalTrial(this.conn) && (this.entity._new || !this.entity.locked)) ||
        // Unpaid, пока имя не сохранено и не скаченное
        (isConUnpaid(this.conn) && this.entity._new) ||
        // Оплаченный слот: Новое, не скаченное и не "звездочка"
        (isConPaid(this.conn) && (this.entity._new || (!this.entity.locked && !entIsWildcard(this.entity))))
      );
    },
    canDeleteEntity: function () {
      return (
        // Еще не сохраненное
        this.license.data._new || this.conn._new ||
        // Набросок
        isDraft(this.license.data) || isConDraft(this.conn) ||
        // Месячный триал, пока имя не сохранено и не скаченно
        (isConNonPersonalTrial(this.conn) && (this.entity._new || !this.entity.locked)) ||
        // Unpaid: если тип "звездочка" или пока имя не сохранено
        (isConUnpaid(this.conn) && (entIsWildcard(this.entity) || this.entity._new)) ||
        // Оплаченный слот: Новое
        (isConPaid(this.conn) && this.entity._new) // || (!this.entity.locked && !entIsWildcard(this.entity))))
      );
    },    
    canSuspendEntity: function () {
      return false;
/*
      return (
        // Оплаченный слот: скаченное либо "эвездочка"
        (isConPaid(this.conn) && (this.entity.locked || entIsWildcard(this.entity)))
      );

 */
    },     
    entityVisibleGroups: function (entity) {
      // Только те что отображаются с маркером
      return entity._validation.groups.filter((g) => g.index > 0);
    },
    entityHasVisibleMessage: function (entity) {
      // Любое не пустое сообщение
      return entity._validation.groups.find((g) => g.message.length > 0);
    },
    entityVisibleMessage: function (entity) {
      let group = null;
      for (let i = 0; i < entity._validation.groups.length; i++) {
        let g = entity._validation.groups[i];
        if (g.message.length > 0) {
          if (!group) {
            group = g;
          } else if (g.msg_type == MSG_TYPE.ERROR) {
            group = g;
          }
        }
      }
      return group;
    },
    entitySuspendingHint: function (entity) {
      return this.$t('license.suspend.hint', [entity.suspended ? this.$t('license.suspend.yes') : this.$t('license.suspend.no')])
    },
    handleDeleteEntity: function (conn_idx, entity_idx) {
      this.license.deleteEntity(conn_idx, entity_idx);
    },
    handleCreateInNewSlot: function () {
      this.license.addSlot(this.license.data, requestedType);
      this.license.validate();
      this.hideWildcardModal();
      this.$nextTick(function () {
        let con_idx = this.license.data.connections.length - 1;
        let element = document.getElementById("slot_" + con_idx);
        element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        this.$nextTick(function () {
          this.$refs.type.$el.blur();
          this.$emit('focus-last-entity');
        });
      });
    },
    hideWildcardModal: function() {
      wildcardModalVisible = false;
      this.$bvModal.hide('wildcard-modal')
    },
    typeChanging: function (event) {
      // Не даем изменить тип на "звездочку" в оплаченном слоте
      if (isConPaid(this.conn) && str2type(event.target.value).wild) {
        if (!wildcardModalVisible) {
          requestedType = event.target.value;
          wildcardModalVisible = true;
          // Фокус надо убрать, иначе он не перескочит на новый слот
          this.$refs.type.$el.blur();
          this.$bvModal.show('wildcard-modal');
        }
        event.target.value = this.entity.connection_type
      }
    },
    typeChanged: function (conn_idx, entity/*, entity_idx*/) {
      if (this.license.isWildcardEntity(entity)) {
        entity.name = WILDCARD;
      } else {
        if (entity.name == WILDCARD) entity.name = "";

        if (!this.isEncryptedOnly() && entity.name == "") {
          this.$refs.input.focus();
        }
      }

      this.license.validate();
      this.license.calcSummary();
    },
    inputChanged: function () {
      this.license.validate();
    },
  },
};
</script>

<style scoped>
.input-group-prepend select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .custom-select.is-valid {
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    right 0.75rem center/8px 10px no-repeat;
}
.input-group .custom-select.is-valid:disabled {
  background-color: #e9ecef;
}
.input-group.group::before {
  content: "";
  height: 2rem;
  width: 0.25em;
  background-color: red;
  position: absolute;
  left: -8px;
  top: calc((100% - 2rem) / 2);
}

.custom-select:disabled {
  color: #495057;
  opacity: 1;
}

.validation-mark {
  min-width: 1rem;
  display: inline-block;
  text-align: center;
}
.encrypted-only:focus::placeholder {
  opacity: 0.5;
}
.encrypted-only::placeholder {
  text-overflow: ellipsis;
  opacity: 1;
  transition: opacity 0.5s ease;
}
</style>